// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3gWXj","subheader":"ReorderModal_subheader__3Z0P-","listWrap":"ReorderModal_listWrap__h6Tyd","inactiveWrap":"ReorderModal_inactiveWrap__1JFFr"};